// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ico":"registration-info-modals__ico--1H_b1","button":"registration-info-modals__button--3F0Xe"};